import React from 'react';

import { makeStyles, Theme } from '@material-ui/core';

import AppBar, { AppBarProps } from '../AppBar';
import Container from '../Container';
import Divider from '../Divider';
import LinearProgress from '../LinearProgress';

const useStyles = makeStyles((theme: Theme) => ({
  progressBarColorPrimary: {
    backgroundColor: theme.palette.secondary.main,
  },
  progressColorPrimary: {
    height: 5,
    backgroundColor: theme.palette.grey[300],
  },
}));

export interface FixedFooterProps {
  appBarProps?: AppBarProps;
  dividerTop?: boolean;
  dividerBottom?: boolean;
  children: React.ReactElement;
  progressBar?: boolean;
  progressBarValue?: number;
}

const FixedFooter: React.FC<FixedFooterProps> = props => {
  const classes = useStyles();

  const {
    children,
    appBarProps,
    dividerTop = false,
    dividerBottom = false,
    progressBar = false,
    progressBarValue = 0,
  } = props;

  return (
    <React.Fragment>
      {progressBar && (
        <LinearProgress
          data-test-locator={`Fixed Footer ProgressBar - ${progressBarValue}`}
          variant="determinate"
          classes={{
            colorPrimary: classes.progressColorPrimary,
            barColorPrimary: classes.progressBarColorPrimary,
          }}
          value={progressBarValue}
        />
      )}
      <AppBar position="static" color="inherit" {...appBarProps}>
        {dividerTop && <Divider data-test-locator="Fixed Footer Divider Top" />}
        <Container>{children}</Container>
        {dividerBottom && (
          <Divider data-test-locator="Fixed Footer Divider Bottom" />
        )}
      </AppBar>
    </React.Fragment>
  );
};

export default FixedFooter;
